export const energyAndWaterSupplyInConstructionConst = {
  path: "/single-programs/energy-and-water-supply-in-construction",
  title: "ИНЖЕНЕРНЫЙ ФАКУЛЬТЕТ – ЭНЕРГЕТИЧЕСКОЕ И ВОДОСНАБЖЕНИЕ В СТРОИТЕЛЬСТВЕ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения:</strong> очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Энергия, вода и технологии — ключ к устойчивому строительству</h2>
      <p>
        Программа готовит экспертов по проектированию, установке и обслуживанию систем жизнеобеспечения зданий: отопление, вентиляция,
        электроснабжение, водоснабжение и канализация. Это направление критически важно для строительства современных, энергоэффективных и
        экологичных объектов.
      </p>
      <p>Обучение сочетает инженерную точность, знание стандартов ЕС и навыки работы с современными технологиями.</p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Теплотехника и системы отопления</li>
        <li>Электроснабжение зданий</li>
        <li>Водоснабжение и водоотведение</li>
        <li>Проектирование инженерных сетей</li>
        <li>Энергоэффективные технологии</li>
        <li>Управление и автоматизация систем</li>
        <li>BIM-проектирование и цифровые платформы</li>
        <li>Экологическая безопасность и нормативы ЕС</li>
      </ul>
      <p>
        Студенты работают с профессиональным ПО, проходят стажировки на объектах и участвуют в разработке решений для устойчивой
        архитектуры.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Инженер по инженерным системам зданий</li>
        <li>Проектировщик по тепло- и водоснабжению</li>
        <li>Специалист по энергоаудиту и энергоэффективности</li>
        <li>Технический консультант в строительной компании</li>
        <li>Руководитель инженерных проектов</li>
        <li>Специалист по эксплуатации инженерной инфраструктуры</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        <strong>от €50,000 до €90,000 в год</strong>
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом, признанный работодателями</li>
        <li>Гибкая форма обучения: очно или дистанционно</li>
        <li>Программа на русском или английском языке</li>
        <li>Стажировки в ведущих инженерных компаниях Европы</li>
        <li>Доступ к современным симуляторам, лабораториям и цифровым платформам</li>
        <li>Поддержка приёмной комиссии на всех этапах поступления</li>
      </ul>
      <p>Инженерные сети — сердце любого здания</p>
      <p>
        Наши выпускники внедряют энергоэффективные решения, повышают экологичность инфраструктуры и работают над устойчивым развитием
        городов.
      </p>
      <br />
      <p className="padding-left">«Энергия и вода — ресурсы будущего. Мы готовим тех, кто умеет ими управлять профессионально.»</p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия поможет вам выбрать оптимальный формат, подготовить документы и подать заявку.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очно или дистанционно
    Форма связи: Получить консультацию приемной комиссии
    Энергия, вода и технологии — ключ к устойчивому строительству
    Программа готовит экспертов по проектированию, установке и обслуживанию систем жизнеобеспечения зданий: отопление, вентиляция, электроснабжение, водоснабжение и канализация. Это направление критически важно для строительства современных, энергоэффективных и экологичных объектов.
    Обучение сочетает инженерную точность, знание стандартов ЕС и навыки работы с современными технологиями.
    Что вы будете изучать?
    • Теплотехника и системы отопления
    • Электроснабжение зданий
    • Водоснабжение и водоотведение
    • Проектирование инженерных сетей
    • Энергоэффективные технологии
    • Управление и автоматизация систем
    • BIM-проектирование и цифровые платформы
    • Экологическая безопасность и нормативы ЕС
    Студенты работают с профессиональным ПО, проходят стажировки на объектах и участвуют в разработке решений для устойчивой архитектуры.
    Кем можно работать после окончания?
    • Инженер по инженерным системам зданий
    • Проектировщик по тепло- и водоснабжению
    • Специалист по энергоаудиту и энергоэффективности
    • Технический консультант в строительной компании
    • Руководитель инженерных проектов
    • Специалист по эксплуатации инженерной инфраструктуры
    Зарплата в Европе: от €50,000 до €90,000 в год
    Почему выбирают нас?
    • Европейский диплом, признанный работодателями
    • Гибкая форма обучения: очно или дистанционно
    • Программа на русском или английском языке
    • Стажировки в ведущих инженерных компаниях Европы
    • Доступ к современным симуляторам, лабораториям и цифровым платформам
    • Поддержка приёмной комиссии на всех этапах поступления
    Инженерные сети — сердце любого здания
    Наши выпускники внедряют энергоэффективные решения, повышают экологичность инфраструктуры и работают над устойчивым развитием городов.
    «Энергия и вода — ресурсы будущего. Мы готовим тех, кто умеет ими управлять профессионально.»

    Как поступить?
    Приёмная комиссия поможет вам выбрать оптимальный формат, подготовить документы и подать заявку.
`,
};
